import Vue from 'vue';
import YandexMaps from 'vue-yandex-maps';

Vue.use(YandexMaps, {
  version: '2.1',
  lang: 'ru_RU',
  apiKey: process.env.VUE_APP_YANDEX_MAP_STRING,
});
